import React, { useState } from "react";
import Countdown, { CountdownRenderProps, zeroPad } from "react-countdown";
import {
  CircularProgressbar as CircularProgress,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { Container, TextMessage } from "./CircularProgressbar.styles";

interface CircularProgressbarProps {
  value: number;
  callbacks?: Array<{ callback(): void; value: number }>;
  message?: string;
}

export const CircularProgressbar = React.forwardRef(
  (
    { value = 0, callbacks, message }: CircularProgressbarProps,
    countdownRef: any
  ) => {
    console.log("INIT countdownRef", countdownRef);

    const [state, setState] = useState({ date: Date.now() + value });

    const handleUpdate = (): void => {
      console.log("handleUpdate", countdownRef);
      // countdownRef?.current && countdownRef.current?.forceUpdate();
    };

    // const handleStartClick = (): void => {
    //   countdownRef && countdownRef?.current?.start();
    // };

    // const handlePauseClick = (): void => {
    //   countdownRef?.current && countdownRef?.current?.pause();
    // };

    const handleResetClick = (): void => {
      setState({ ...state, date: Date.now() + value });
    };

    React.useImperativeHandle(countdownRef, () => ({
      ...countdownRef?.current,
      resetCounter: handleResetClick,
    }));

    // const isPaused = (): boolean => {
    //   return !!(countdownRef?.current && countdownRef?.current?.isPaused());
    // };

    // const isCompleted = (): boolean => {
    //   return !!(
    //     countdownRef?.current?.countdownApi &&
    //     countdownRef?.current?.isCompleted()
    //   );
    // };

    const onTick = (value: any): void => {
      // console.log("asd", value);
    };

    const renderer = ({
      minutes,
      seconds,
      milliseconds,
      total,
    }: CountdownRenderProps) => {
      if (callbacks) {
        callbacks.forEach((callback) => {
          if (callback?.value === minutes + seconds) {
            callback?.callback();
          }
        });
      }

      return (
        <div className="containerProgress">
          <div className="containerCircularProgress">
            <CircularProgress
              background
              styles={buildStyles({
                strokeLinecap: "butt",
                trailColor: "#D9DFF8",
                pathColor: "#FFAA00",
              })}
              value={120 - total / 1000}
              strokeWidth={50}
              minValue={0}
              maxValue={120}
            />
          </div>
          <h4>
            {zeroPad(minutes)}m {zeroPad(seconds)}s
          </h4>
          <TextMessage status={message || total === 0 ? "danger" : "normal"}>
            {!message && total !== 0 && "Tempo restante"}
            {!message && total === 0 && "O código expirou"}
            {!!message && message}
          </TextMessage>
        </div>
      );
    };

    return (
      <Container>
        <Countdown
          ref={countdownRef}
          key={state.date}
          autoStart={true}
          date={state.date}
          onTick={onTick}
          onStart={handleUpdate}
          onMount={handleUpdate}
          onPause={handleUpdate}
          onComplete={handleUpdate}
          intervalDelay={1000}
          precision={3}
          renderer={renderer}
          zeroPadTime={2}
        />
      </Container>
    );
  }
);
